<template>
  <div class="perfil-usuario" :style="fondoEstilo">
    <h2 class="titulo">Mi Perfil</h2>
    <div class="formulario">
      <b-field label="Número de teléfono">
        <b-input v-model="usuario.telefono"></b-input>
      </b-field>
      <b-field label="Nombre de quien califica">
        <b-input v-model="usuario.nombre"></b-input>
      </b-field>
      <b-field label="Dirección">
        <b-input v-model="usuario.direccion"></b-input>
      </b-field>
      <div class="buttons is-centered mt-3">
        <b-button
          type="is-primary"
          @click="guardar"
          style="background-color: #2c73d2; border-color: #2c73d2; color: white"
        >
          Guardar
        </b-button>
        <b-button type="is-danger" @click="salir">Cerrar sesión</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { ColorContrasteMixin } from "./mixins/ColorContrasteMixin";
import {
  guardarDatosSesion,
  obtenerDatosSesion,
} from "@/utils/sesionCalificacion";

export default {
  name: "PerfilUsuario",
  mixins: [ColorContrasteMixin],
  props: {
    color: {
      type: String,
      default: "#1e293b",
    },
  },
  data() {
    return {
      usuario: {
        nombre: "",
        telefono: "",
        direccion: localStorage.getItem("direccionUsuario") || "",
      },
    };
  },
  computed: {
    fondoEstilo() {
      const c = this.color || "#1e293b";
      return {
        background: c,
        color: this.colorContraste(c),
        padding: "1rem",
        borderRadius: "8px",
      };
    },
  },
  created() {
    const datos = obtenerDatosSesion();
    if (datos) {
      this.usuario.telefono = datos.telefono || "";
      this.usuario.nombre = datos.nombre || "";
    }
  },
  methods: {
    guardar() {
      guardarDatosSesion({
        telefono: this.usuario.telefono,
        nombre: this.usuario.nombre,
      });
      localStorage.setItem("direccionUsuario", this.usuario.direccion);
      Swal.fire({
        icon: "success",
        text: "Datos guardados localmente",
        background: "#1e293b",
        color: "#fff",
      });
    },
    salir() {
      localStorage.removeItem("id");
      localStorage.removeItem("idUsuario");
      localStorage.removeItem("direccionUsuario");
      localStorage.removeItem("validado");
      localStorage.removeItem("datosCalificador");
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.perfil-usuario {
  max-width: 400px;
  margin: 0 auto;
}
</style>

